module.exports = __webpack_public_path__ + "img/checked_bgWhite_g.370d5d12.svg";